import { useLocation, withRouter } from "react-router";
import React, { useContext, useEffect, useRef, useState } from 'react';
import AppNav from "./AppNav";
import 'react-toastify/dist/ReactToastify.css';
import { deleteAPI, downloadAPI, getAPI, patchAPI, postAPI, putAPI } from "../APIUtil";
import Button from "react-bootstrap/Button";
import { Card, Col, Container, Form, InputGroup, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker"
import {
  faCalendar,
  faCalendarAlt,
  faFileDownload,
  faList,
  faPlusCircle, faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { PayDtlLine } from "./PayDtlLine";
import {
  addField,
  amountFormatter,
  checkKey,
  dateformatDB,
  dateformatJPNYYYYMMDD,
  finishLoadingBtn,
  formatNumber,
  lpad,
  nvl,
  parseDate,
  parseDatetime,
  startLoadingBtn,
  toNull,
  onFocusText,
  dateformatDatePicker,
  toSingleByteNumberOnly,
  nextStatusByApprove,
  r,
  R_ROUND,
  dispPayGrpStatus,
  CONST_EXPENSE_CL_TAX_10,
  CONST_EXPENSE_CL_TAX_EXEMPT,
  CONST_EXPENSE_CL_TAX_NON_TAX,
  CONST_EXPENSE_CL_TAX_08,
  rpad,
  onKeyDownNext,
  sleepByPromise,
  moveFocusByTabIndex,
  onKeyDownShortCut,
  isEnterKey, focusById, dateformatYYYY_MM, dateformatDatePickerYYYYMM, dateformatYYYY_MM_DD, isTaxInclude, isExpense
} from "../CMUtil";
import AsyncSelect from "react-select/async";
import { Link, useHistory } from "react-router-dom";
import { GlobalContext } from "../Global";
import Toast, { error, success } from "../Toast";
import { PayGrpList } from "./common/PayGrpList";
import { ApproveList } from "./common/ApproveList";
import { PayDateDialog } from "./common/PayDate";
import { RoutePaths } from "./PageRoutesAuthenticated";

export const PayDtl = ({ match: { params: { pay_id } } }) => {

  const search = useLocation().search;
  const history = useHistory();

  let searchCondition;
  let res;
  let obj;

  const { loginUser, setLoginUser } = useContext(GlobalContext);
  //AnsySelect表示
  const [selectMenuOpen, setSelectMenuOpen] = useState(false);
  const [expDateIsOpen, setExpDateIsOpen] = useState(false);
  const [payDateIsOpen, setPayDateIsOpen] = useState(false);

  //支払ヘッダ
  const [payId, setPayId] = useState("");
  const [payDate, setPayDate] = useState("");
  const [payGrpType, setPayGrpType] = useState("原稿料");
  const [payGrpNum, setPayGrpNum] = useState("");
  const [disabledBtnPaySave, setDisabledBtnPaySave] = useState(true);
  const [expDate, setExpDate] = useState("");
  const [payGrpStatus, setPayGrpStatus] = useState("");
  const [schedulePayMonth, setSchedulePayMonth] = useState("");
  const [costCd, setCostCd] = useState("");
  const [picName, setPicName] = useState("");
  const [itemCd, setItemCd] = useState("");
  const [itemName, setItemName] = useState("");
  const [distributionDate, setDistributionDate] = useState("");
  const [grpNameS, setGrpNameS] = useState("");

  const [sysConsumptionTaxCl, setSysConsumptionTaxCl] = useState("");
  const [sysRoundingOffCl, setSysRoundingOffCl] = useState("");

  const [subAmount, setSubAmount] = useState("");
  const [taxAmount, setTaxAmount] = useState("");
  const [totalAmount, setTotalAmount] = useState("");

  const [status, setStatus] = useState("");
  const [note, setNote] = useState("");

  //内訳
  const [lineList, setLineList] = useState([]);
  const iniPayId = useRef(true);
  const iniExpDate = useRef(true);
  const iniPayDate = useRef(true);
  const iniPayGrpNum = useRef(true);
  const [preventOpenOnFocusExpDate, setPreventOpenOnFocusExpDate] = useState(true);

  // 内訳ダイアログ
  const [modalAuthorSelected, setModalAuthorSelected] = useState(null);
  const [modalAuthorCd, setModalAuthorCd] = useState("");
  const [modalDeptSelected, setModalDeptSelected] = useState(null);
  const [modalDeptCd, setModalDeptCd] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modalShowAddInfo, setModalShowAddInfo] = useState(false);
  const [modalLineList, setModalLineList] = useState([]);
  const modalLineListRef = useRef([]);

  const [modalExpenseList, setModalExpenseList] = useState([]);
  const [modalRemarkList, setModalRemarkList] = useState([]);
  const [modalAccList, setModalAccList] = useState([]);
  const [modalAccSuffixList, setModalAccSuffixList] = useState([]);

  const [modalDispAuthorCd, setModalDispAuthorCd] = useState("");
  const [modalDispAuthorPennameNm, setModalDispAuthorPennameNm] = useState("");
  const [modalDispAuthorTel, setModalDispAuthorTel] = useState("");
  const [modalDispAuthorCellPhoneNo, setModalDispAuthorCellPhoneNo] = useState("");
  const [modalDispAuthorAddr, setModalDispAuthorAddr] = useState("");
  const [modalDispAuthorAddrSend, setModalDispAuthorAddrSend] = useState("");
  const [modalDispAuthorTelSend, setModalDispAuthorTelSend] = useState("");
  const [modalDispEmailAddressAuthor, setModalDispEmailAddressAuthor] = useState("");
  const [modalDispBankAccountNm, setModalDispBankAccountNm] = useState("");
  const [modalDispBankAccount, setModalDispBankAccount] = useState("");
  const [modalDutyFreeFG, setModalDutyFreeFG] = useState("");
  const [modalDispAuthorTekikakuNo, setModalDispAuthorTekikakuNo] = useState("");

  const [modalCommorancyCl, setModalCommorancyCl] = useState(0);
  const [modalConsumptionTax, setModalConsumptionTax] = useState("2");
  const [modalRoundingOffCl, setModalRoundingOffCl] = useState("");
  const [modalWithholdingObjectCl, setModalWithholdingObjectCl] = useState("");

  const [modalSubAmt10, setModalSubAmt10] = useState(0);
  const [modalTaxAmt10, setModalTaxAmt10] = useState(0);
  const [modalSubAmtEx10, setModalSubAmtEx10] = useState(0);
  const [modalTaxAmtEx10, setModalTaxAmtEx10] = useState(0);
  const [modalSubAmtEx08, setModalSubAmtEx08] = useState(0);
  const [modalTaxAmtEx08, setModalTaxAmtEx08] = useState(0);
  const [modalSubAmtExExempt, setModalSubAmtExExempt] = useState(0);
  const [modalTaxAmtExExempt, setModalTaxAmtExExempt] = useState(0);
  const [modalSubAmtExNonTax, setModalSubAmtExNonTax] = useState(0);
  const [modalTaxAmtExNonTax, setModalTaxAmtExNonTax] = useState(0);
  const [modalTotalAmount, setModalTotalAmount] = useState(0);
  const [modalTotalAmt, setModalTotalAmt] = useState(0);
  const [modalWithholdTaxAmount, setModalWithholdTaxAmount] = useState(0);
  const [modalWithholdTaxAmt, setModalWithholdTaxAmt] = useState(0);
  const [modalHandlingCharge, setModalHandlingCharge] = useState(0);
  const [modalPayAmount, setModalPayAmount] = useState(0);
  const [modalPayAmt, setModalPayAmt] = useState(0);

  const [modalSumQty, setModalSumQty] = useState(0);
  const [modalSumPage, setModalSumPage] = useState(0);
  const [modalSumAmount, setModalSumAmount] = useState(0);
  const [modalSumAmountEx, setModalSumAmountEx] = useState(0);

  // 承認ダイアログ
  const [appModalShow, setAppModalShow] = useState(false);
  const [appModalNote, setAppModalNote] = useState("");
  const [appHistList, setAppHistList] = useState([]);

  // 基準日ダイアログ
  const [modalPayDateShow, setModalPayDateShow] = useState(false);
  const [modalPayDateMonth, setModalPayDateMonth] = useState("");
  const [modalPayDateList, setModalPayDateList] = useState([]);

  const [dispCount, setDispCount] = useState(1);

  const asyncSelectStyles = {
    option: (base, { data }) => ({
      ...base,
      whiteSpace: "pre-wrap",
      fontWeight: data.isHeader ? "bold" : base.fontWeight,
      color: data.isHeader ? "black" : base.color,
    }),
    singleValue: (base, { data }) => ({
      ...base,
      whiteSpace: "pre-wrap",
      fontWeight: data.isHeader ? "bold" : base.fontWeight,
      color: data.isHeader ? "black" : base.color,
    }),
  };

  // 支払ステータスダイアログ
  const [payGrpModalShow, setPayGrpModalShow] = useState(false);

  // 確認ダイアログ
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [confirmModalType, setConfirmModalType] = useState("");

  // HOOKイベント ///////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    const update = async () => {
      setPayId(payId ? payId : pay_id);
    }
    update();
  }, []);

  useEffect(() => {
    if (iniPayId.current) {
      iniPayId.current = false;
      return;
    }
    const update = async () => {
      let cPayId = payId ? payId : pay_id;
      let cItemCd = itemCd ? itemCd : new URLSearchParams(search).get("item_cd");
      let cPayDate = "";
      let cPayGrpNum = "";
      let cExpDate = "";
      let cPicName = "";
      let cStatus = "";
      let cNote = "";
      let cLineList = [];
      let cSchedulePayMonth = "";
      let cItemName = "";
      let cDistributionDate = "";
      let cCostCd = "";
      let cGrpNameS = "";
      let cDisabledBtnPaySave = true;

      let searchCondition = {};
      let res = null;

      //　支払情報
      if (!cPayId) {
        cExpDate = dateformatDB(new Date());
        iniPayDate.current = false;
        cDisabledBtnPaySave = false;
      } else {
        iniPayDate.current = true; // payDate変更時のeffectがDBの値を上書きしないようにguardをリセット
        obj = await getAPI("tr_pay/" + pay_id);
        cPayGrpNum = nvl(obj.pay_grp_num);
        cCostCd = nvl(obj.cost_cd);
        cPayDate = obj.pay_date;
        cExpDate = obj.exp_date;
        if (obj.pic_user) {
          cPicName = nvl(obj.pic_user.name);
        }
        cStatus = obj.status ? nvl(obj.status) : "新規";
        cNote = nvl(obj.note);
        //内訳
        searchCondition = {
          pay_id: cPayId
        }
        res = await getAPI("tr_pay_dtl_list_search_view", searchCondition);
        cLineList = res.results;
        cItemCd = obj.item_cd;
        if (cLineList.length > 0 && (!obj.status || obj.status === "新規" || obj.status === "支払前" || obj.status === "処理中")) {
          cDisabledBtnPaySave = false;
        }
      }

      //　商品マスタ
      if (cItemCd) {
        searchCondition = {
          item_cd: cItemCd
        }
        res = await getAPI("ms_item_search_view", searchCondition);
        obj = res.results[0];
        cItemName = nvl(obj.item_name);
        if (obj.Distribution_DT) {
          cDistributionDate = dateformatYYYY_MM_DD(parseDatetime(obj.Distribution_DT.substring(0, 19)))
        }

        searchCondition = {
          grp_cd_l: obj.grp_cd_l,
          grp_cd_m: obj.grp_cd_m,
          grp_cd_s: obj.grp_cd_s
        };
        res = await getAPI("ms_grp_s_search_view", searchCondition);
        obj = res.results[0];
        cGrpNameS = nvl(obj.grp_name_s);

        searchCondition = {
          item_cd: cItemCd
        }
        res = await getAPI("ms_item02_search_view", searchCondition);
        if (res.count > 0) {
          obj = res.results[0];
          cCostCd = nvl(obj.project_cd);
          if (obj.ym_scheduled_pay) {
            cSchedulePayMonth = dateformatYYYY_MM(parseDate(obj.ym_scheduled_pay + "01"));
          }
          if (obj.Editor_CD_1) {
            cPicName = obj.Editor_CD_1;
          } else if (obj.Editor_CD_2) {
            cPicName = obj.Editor_CD_2;
          } else if (obj.Editor_CD_3) {
            cPicName = obj.Editor_CD_3;
          }
        }
      }

      // 印税システム管理マスタ
      searchCondition = {
        pay_date: payDate
      }
      res = await getAPI("ms_royalty", searchCondition);
      if (res.count > 0) {
        setSysConsumptionTaxCl(nvl(res.results[0].consumption_tax_cl));
        setSysRoundingOffCl(nvl(res.results[0].rounding_off_cl));
      }

      setPayId(cPayId);
      setPayGrpNum(cPayGrpNum);
      setPayDate(cPayDate);
      setExpDate(cExpDate);
      setPicName(cPicName);
      setStatus(cStatus);
      setNote(cNote);
      setLineList(cLineList);
      setSchedulePayMonth(cSchedulePayMonth);
      setDistributionDate(cDistributionDate);
      setCostCd(cCostCd);
      setPicName(cPicName);
      setItemCd(cItemCd);
      setItemName(cItemName);
      setGrpNameS(cGrpNameS);
      calcAmounts(cLineList);
      setDisabledBtnPaySave(cDisabledBtnPaySave);

      await sleepByPromise(0.02);
      $("#expDate").select();
    }

    update();

  }, [payId, dispCount]);

  useEffect(() => {
    if (iniPayDate.current) {
      iniPayDate.current = false;
      return;
    }

    const update = async () => {
      if (!payDate) {
        return;
      }
      let searchCondition = {};
      // グループセット
      searchCondition = {
        pay_grp_type: "原稿料",
        pay_date: payDate,
        selected: true
      }
      let res = await getAPI("ms_pay_grp", searchCondition);
      if (res.count >= 1) {
        // 選択中グループがある場合
        // 新規作成時のみ Gno を自動セット（修正時は手入力のみ変更可）
        if (!payId) {
          setPayGrpNum(res.results[0].pay_grp_num);
        }
        setPayGrpStatus(dispPayGrpStatus(res.results[0]));

      } else {
        // 選択中グループがない場合
        // 新規作成時のみ Gno を自動セット（修正時は手入力のみ変更可）
        if (!payId) {
          searchCondition = {
            pay_grp_type: "原稿料",
            pay_date: toNull(payDate),
            sort_field: "pay_grp_num",
            sort_order: "desc"
          }
          res = await getAPI("ms_pay_grp", searchCondition);
          if (res.count >= 1) {
            setPayGrpNum(res.results[0].pay_grp_num + 1);
          } else {
            setPayGrpNum(1);
          }
        }
        setPayGrpStatus("支払前");
      }
    }

    update();

  }, [payDate]);

  useEffect(() => {

    const update = async () => {

      let clist = JSON.parse(JSON.stringify(modalPayDateList));
      let hasEmptyRow = false;
      clist.forEach((payDate) => {
        if (!payDate.pay_date) {
          hasEmptyRow = true;
        }
      });

      if (!hasEmptyRow) {
        //空行の追加
        clist.push({
          pay_date_id: "",
          pay_date: "",
          remark: ""
        });
        setModalPayDateList(clist);
      }
    }
    update();
  }, [modalPayDateList]);

  useEffect(() => {
    if (iniPayGrpNum.current) {
      iniPayGrpNum.current = false;
      return;
    }
    if (!payDate) {
      return;
    }
    const update = async () => {
      let cPayGrpStatus = "";
      if (payGrpNum) {
        // グループセット
        cPayGrpStatus = "支払前";
        let searchCondition = {
          pay_grp_type: payGrpType,
          pay_date: dateformatDB(payDate),
          pay_grp_num: payGrpNum
        }
        let res = await getAPI("ms_pay_grp_search_view", searchCondition);
        if (res.count === 1) {
          obj = res.results[0];
          cPayGrpStatus = dispPayGrpStatus(obj);
        }
      }
      setPayGrpStatus(cPayGrpStatus);
    }

    update();

  }, [payGrpNum]);

  // 内訳画面 ////////////////////////////////////////////////////////////////////////////////////
  const onClickPaySave = async () => {

    // 入力チェック
    if (!expDate) {
      error("処理日を入力してください");
      return
    }
    if (!payDate) {
      error("支払日を入力してください");
      return
    }
    if (!payGrpNum) {
      error("Gnoを入力してください");
      return
    }
    if (lineList.length == 0) {
      error("明細を入力してください");
      return
    }

    let obj = {};

    // グループ作成
    if (payDate) {
      let searchCondition = {
        pay_grp_type: payGrpType,
        pay_date: dateformatDB(payDate),
        pay_grp_num: payGrpNum
      }
      let res = await getAPI("ms_pay_grp_search_view", searchCondition);
      if (res.count === 0) {
        // グループ追加
        obj = {
          pay_grp_type: payGrpType,
          pay_date: dateformatDB(payDate),
          pay_grp_num: payGrpNum,
          selected: true
        }
        obj = await postAPI("ms_pay_grp/", obj);
        setPayGrpStatus(dispPayGrpStatus(obj));
      }

      // 選択中を解除
      searchCondition = {
        pay_grp_type: payGrpType,
        selected: true
      }
      res = await getAPI("ms_pay_grp_search_view", searchCondition);
      for (let payGrp of res.results) {
        if (payGrp.pay_grp_type === payGrpType && payGrp.pay_date === payDate && payGrp.pay_grp_num === payGrpNum) {
          //今回利用分はスキップ
          continue;
        }
        payGrp.selected = false;
        payGrp = await putAPI("ms_pay_grp/" + payGrp.pay_grp_id + "/", payGrp);
      }

      // 選択中にする
      searchCondition = {
        pay_grp_type: payGrpType,
        pay_date: payDate,
        pay_grp_num: payGrpNum
      }
      res = await getAPI("ms_pay_grp_search_view", searchCondition);
      if (!res.results[0].selected) {
        let cPayGrp = res.results[0];
        cPayGrp.selected = true;
        cPayGrp = await putAPI("ms_pay_grp/" + cPayGrp.pay_grp_id + "/", cPayGrp);
      }
    }

    obj = {};

    if (!payId) {
      //新規登録
      obj.item_cd = itemCd;
      obj.status = '支払前';
      obj.pay_date = payDate;
      obj.pay_grp_type = toNull(payGrpType);
      obj.pay_grp_num = toNull(payGrpNum);
      obj.exp_date = dateformatDB(expDate);
      obj.note = toNull(note);
      obj.sub_amount = toNull(subAmount);
      obj.tax_amount = toNull(taxAmount);
      obj.total_amount = toNull(totalAmount);
      obj = await postAPI("tr_pay/", obj);
      history.push("/pay_dtl/" + obj.pay_id + "/");
      setPayId(obj.pay_id);
    } else {
      //更新
      obj.pay_date = payDate;
      obj.pay_grp_type = toNull(payGrpType);
      obj.pay_grp_num = toNull(payGrpNum);
      obj.exp_date = dateformatDB(expDate);
      obj.note = toNull(note);
      obj.sub_amount = toNull(subAmount);
      obj.tax_amount = toNull(taxAmount);
      obj.total_amount = toNull(totalAmount);
      obj = await patchAPI("tr_pay/" + payId + "/", obj);
    }

    setDispCount(dispCount + 1);
    success("保存しました");
  }

  const calcAmounts = (cLineList) => {
    let cTotalAmount = 0;
    for (let dtl of cLineList) {
      for (let line of dtl.dtl_list) {
        cTotalAmount += line.line_total_amount ? line.line_total_amount : 0;
      }
    }
    setTotalAmount(cTotalAmount);
  }

  const onClickDownload = async () => {

    startLoadingBtn("btn-download", "secondary");

    let condition = {};
    addField(condition, "pay_id", payId);
    await downloadAPI("download/pay_dtl", condition);
    finishLoadingBtn("btn-download");
  }

  const onClickNewPayDtl = async () => {
    history.push("/pay_dtl/?item_cd=" + itemCd);
    setPayId("");
    setDispCount(dispCount + 1);
  }

  // 支払先別内訳ダイアログ ////////////////////////////////////////////////////////////////////////
  const onClickShowModal = async (pModalAuthorCd) => {

    let cList = [];
    let cModalDispAuthorCd = "";
    let cModalDispAuthorPennameNm = "";
    let cModalDispAuthorTel = "";
    let cModalDispAuthorCellPhoneNo = "";
    let cModalDispAuthorAddr = "";
    let cModalDispAuthorAddrSend = "";
    let cModalDispAuthorTelSend = "";
    let cModalDispEmailAddressAuthor = "";
    let cModalDispBankAccountNm = "";
    let cModalDispBankAccount = "";
    let cModalCommorancyCl = 0;
    let cModalConsumptionTax = "";
    let cModalRoundingOffCl = "";
    let cModalWithholdingObjectCl = "";
    let cModalDutyFreeFG = "";
    let cModalDispAuthorTekikakuNo = "";
    let cModalDeptSelected = {};
    let cModalDeptCd = "";

    if (!pModalAuthorCd) {
      // 追加の場合
      setModalAuthorSelected(null);
      for (let i = 0; i < 10; i++) {
        cList.push({ pay: { pay_id: payId } });
      }

      // 同じpay_idのtr_pay_dtlが存在する場合、そのdeptコードをデフォルトとして利用する(line_noで最初のレコード)
      searchCondition = { pay_id: payId };
      res = await getAPI("tr_pay_dtl_list_search_view", searchCondition);
      if (res.count > 0 && res.results[0].dtl_list.length > 0 && res.results[0].dtl_list[0].dept_cd) {
        res = await getAPI("ms_dept", { dept_cd: res.results[0].dtl_list[0].dept_cd });
        let dept = res.results[0];
        cModalDeptSelected = { id: dept.dept_cd, name: lpad(nvl(dept.dept_cd), 2, "0") + " " + nvl(dept.dept_nm) };
        cModalDeptCd = dept.dept_cd;
      }

    } else {
      // 更新の場合

      // 支払先セット
      let obj = null;
      let searchCondition = {
        customer_cd: pModalAuthorCd
      };
      res = await getAPI("ms_author_search_view", searchCondition);
      if (res.count > 0) {
        obj = res.results[0];
      }
      if (obj) {
        setModalAuthorCd(obj.author_cd);
        setModalAuthorSelected({
          option:
            nvl(obj.author_cd) + "　" + nvl(obj.customer_nm),
          id: obj.author_cd,
          name:
            nvl(obj.author_cd) + "　" + nvl(obj.customer_nm)
        });

        cModalDispAuthorCd = nvl(obj.author_cd);
        cModalDispAuthorPennameNm = nvl(obj.penname_nm);
        cModalDispAuthorTel = nvl(obj.author_tel);
        cModalDispAuthorCellPhoneNo = nvl(obj.author_cell_phone_no);
        cModalDispAuthorAddr = nvl(obj.author_zipcode) + " " + nvl(obj.author_address_1) + nvl(obj.author_address_2) + nvl(obj.author_address_3);
        cModalDispAuthorAddrSend = nvl(obj.zipcode_send1) + " " + nvl(obj.address1_send1) + nvl(obj.address1_send2) + nvl(obj.address1_send3);
        cModalDispAuthorTelSend = nvl(obj.tel_send1);
        cModalDispEmailAddressAuthor = nvl(obj.email_address_author);
        cModalCommorancyCl = nvl(obj.commorancy_cl);
        cModalConsumptionTax = obj.consumption_tax === 0 ? sysConsumptionTaxCl : nvl(obj.consumption_tax);
        cModalRoundingOffCl = obj.rounding_off_cl === 0 ? sysRoundingOffCl : nvl(obj.rounding_off_cl);
        cModalWithholdingObjectCl = nvl(obj.withholding_object_cl);
        cModalDutyFreeFG = nvl(obj.duty_free);
        cModalDispAuthorTekikakuNo = nvl(obj.author_tekikaku_no);

        // 口座情報セット
        cModalDispBankAccountNm = nvl(obj.bank_account_nm);
        searchCondition = {
          bank_cd: obj.bank_cd,
          bank_branch_cd: obj.bank_branch_cd
        }
        let oBank = await getAPI("ms_bank", searchCondition);
        if (oBank.count === 1) {
          let o = oBank.results[0];
          cModalDispBankAccount = "";
          cModalDispBankAccount += nvl(o.bank_nm);
          cModalDispBankAccount += "(" + nvl(o.bank_cd) + ")";
          cModalDispBankAccount += "　";
          cModalDispBankAccount += nvl(o.bank_branch_nm);
          cModalDispBankAccount += "(" + nvl(o.bank_branch_cd) + ")";
          cModalDispBankAccount += "　";
          if (obj.kind_of_account_cl === "0") {
            cModalDispBankAccount += "普通";
          } else if (obj.kind_of_account_cd === "1") {
            cModalDispBankAccount += "当座";
          } else if (obj.kind_of_account_cd === "9") {
            cModalDispBankAccount += "総合";
          }
          cModalDispBankAccount += "　";
          cModalDispBankAccount += nvl(obj.bank_account_no);
        }
      }

      // 内訳セット
      searchCondition = {
        pay_id: payId,
        author_cd: pModalAuthorCd
      }
      res = await getAPI("tr_pay_dtl_list_search_view", searchCondition);
      cList = res.results[0].dtl_list;
      while (cList.length < 11) {
        cList.push({
          pay_id: payId,
          line_tax_type_cd: cModalConsumptionTax // 初期値
        });
      }

      if (cList[0].dept_cd) {
        res = await getAPI("ms_dept", { dept_cd: cList[0].dept_cd });
        let dept = res.results[0];
        cModalDeptSelected = { id: dept.dept_cd, name: lpad(nvl(dept.dept_cd), 2, "0") + " " + nvl(dept.dept_nm) };
        cModalDeptCd = cList[0].dept_cd;
        // setModalDeptSelected([{id: dept.dept_cd, name: lpad(nvl(dept.dept_cd), 2, "0") + " " + nvl(dept.dept_nm)}]);
        // setModalDeptCd(cList[0].dept_cd);
      }
    }

    setModalDispAuthorCd(cModalDispAuthorCd);
    setModalDispAuthorPennameNm(cModalDispAuthorPennameNm);
    setModalDispAuthorTel(cModalDispAuthorTel);
    setModalDispAuthorCellPhoneNo(cModalDispAuthorCellPhoneNo);
    setModalDispAuthorAddr(cModalDispAuthorAddr);
    setModalDispAuthorAddrSend(cModalDispAuthorAddrSend);
    setModalDispAuthorTelSend(cModalDispAuthorTelSend);
    setModalDispEmailAddressAuthor(cModalDispEmailAddressAuthor);
    setModalDispBankAccountNm(cModalDispBankAccountNm);
    setModalDispBankAccount(cModalDispBankAccount);
    setModalCommorancyCl(cModalCommorancyCl);
    setModalConsumptionTax(cModalConsumptionTax);
    setModalRoundingOffCl(cModalRoundingOffCl);
    setModalWithholdingObjectCl(cModalWithholdingObjectCl);
    setModalDutyFreeFG(cModalDutyFreeFG);
    setModalDispAuthorTekikakuNo(cModalDispAuthorTekikakuNo);
    setModalDeptSelected(cModalDeptSelected);
    setModalDeptCd(cModalDeptCd);

    modalLineListRef.current = [];
    for (let i = 0; i < cList.length; i++) {
      modalLineListRef.current[i] = React.createRef();
    }
    setModalLineList(cList);
    // totaling(cList);

    // 種目リスト
    searchCondition = { expense_cl_nm: "", pay_grp_type:"原稿料" };
    res = await getAPI("ms_expense_typeahead_view", searchCondition);
    const cExpenseList = [];
    for (const obj of res.results) {
      cExpenseList.push({
        name: lpad(nvl(obj.expense_cl), 2, "0") + " " + nvl(obj.expense_cl_nm),
        id: obj.expense_cl
      });
    }
    setModalExpenseList(cExpenseList);

    // 科目リスト
    searchCondition = { search_value: "" };
    res = await getAPI("ms_acc1_typeahead_view", searchCondition);
    const cAccList = [];
    for (const obj of res.results) {
      cAccList.push({
        name: lpad(nvl(obj.acc_cd), 3, "0") + " " + nvl(obj.acc_nm),
        id: obj.acc_cd
      });
    }
    setModalAccList(cAccList);

    // 補助科目リスト
    searchCondition = { search_value: "" };
    res = await getAPI("ms_acc2_typeahead_view", searchCondition);
    const cAccSuffixList = [];
    for (const obj of res.results) {
      cAccSuffixList.push({
        acc_cd: obj.acc_cd,
        id: obj.acc_suffix_cd,
        name: lpad(nvl(obj.acc_suffix_cd), 3, "0") + " " + nvl(obj.acc_suffix_nm),
      });
    }
    setModalAccSuffixList(cAccSuffixList);

    // 摘要リスト
    searchCondition = { remark_nm: "" };
    res = await getAPI("ms_remark_typeahead_view", searchCondition);
    const cRemarkList = [];
    for (const obj of res.results) {
      cRemarkList.push({
        name: nvl(obj.remark_cd) + " " + nvl(obj.remark_nm),
        id: obj.remark_cd,
        remark_nm: nvl(obj.remark_nm)
      });
    }
    setModalRemarkList(cRemarkList);

    setModalShow(true);
    await sleepByPromise(0.02);
    moveFocusByTabIndex(1010); //支払先をフォーカス
  }

  const onClickCloseModal = async () => {
    setModalLineList([]);
    setModalShow(false);
    await focusById("expDate");
  }

  const appendLine = async () => {
    let emptyLineCnt = 0;
    modalLineListRef.current.map(lineList => {
      if (lineList.current.isEmpty()) {
        emptyLineCnt += 1;
      }
    });

    if (emptyLineCnt < 1) {
      let cModalLineList = modalLineList;
      cModalLineList = JSON.parse(JSON.stringify(cModalLineList));
      cModalLineList.push({ pay: { pay_id: payId } });
      modalLineListRef.current[modalLineListRef.current.length] = React.createRef();
      setModalLineList(cModalLineList);
    }
  }

  const onClickShowModalAddInfo = () => {
    setModalShowAddInfo(!modalShowAddInfo);
  }

  const onClickSavePayDtlModal = async () => {

    let cModalLineList = [];
    modalLineListRef.current.map(lineList => {
      let o = lineList.current.getStates();
      if (o.pay_dtl_id || o.expense_cl) {
        cModalLineList.push(o);
      }
    });

    // 入力チェック
    if (!modalAuthorCd) {
      error("支払先を入力してください");
      return
    }
    if (cModalLineList.length == 0) {
      error("明細を入力してください");
      return
    }


    let obj = {};
    // グループ作成
    if (payDate) {
      let searchCondition = {
        pay_grp_type: payGrpType,
        pay_date: payDate,
        pay_grp_num: payGrpNum
      }
      let res = await getAPI("ms_pay_grp_search_view", searchCondition);
      if (res.count === 0) {
        // グループ追加
        obj = {
          pay_grp_type: payGrpType,
          pay_date: payDate,
          pay_grp_num: payGrpNum,
          status: "支払前",
          selected: true
        }
        obj = await postAPI("ms_pay_grp/", obj);
        setPayGrpStatus(dispPayGrpStatus(obj));
      }
      // 選択中を解除
      searchCondition = {
        pay_grp_type: payGrpType,
        selected: true
      }
      res = await getAPI("ms_pay_grp_search_view", searchCondition);
      for (let payGrp of res.results) {
        if (payGrp.pay_grp_type === payGrpType && payGrp.pay_date === payDate && payGrp.pay_grp_num === payGrpNum) {
          //今回利用分はスキップ
          continue;
        }
        payGrp.selected = false;
        payGrp = await putAPI("ms_pay_grp/" + payGrp.pay_grp_id + "/", payGrp);
      }
      // 選択中にする
      searchCondition = {
        pay_grp_type: payGrpType,
        pay_date: payDate,
        pay_grp_num: payGrpNum
      }
      res = await getAPI("ms_pay_grp_search_view", searchCondition);
      if (!res.results[0].selected) {
        let cPayGrp = res.results[0];
        cPayGrp.selected = true;
        cPayGrp = await putAPI("ms_pay_grp/" + cPayGrp.pay_grp_id + "/", cPayGrp);
      }
    }

    let cPayId = payId;
    if (!cPayId) {
      //ヘッダ登録
      let obj = {};
      obj.item_cd = toNull(itemCd);
      obj.status = "支払前";
      obj.pay_date = payDate;
      obj.pay_grp_type = toNull(payGrpType);
      obj.pay_grp_num = toNull(payGrpNum);
      obj.exp_date = dateformatDB(expDate);
      obj.note = toNull(note);
      obj.sub_amount = toNull(subAmount);
      obj.tax_amount = toNull(taxAmount);
      obj.total_amount = toNull(totalAmount);
      obj = await postAPI("tr_pay/", obj);
      cPayId = obj.pay_id;
      history.push("/pay_dtl/" + cPayId + "/");
      setPayId(cPayId);
    }

    cModalLineList = await modalBulkSave(cPayId, cModalLineList);

    // tr_pay 集計更新
    const allLinesRes = await getAPI("tr_pay_dtl_list_search_view", { pay_id: cPayId });
    let allLines = [];
    for (const authLine of allLinesRes.results) {
      allLines = allLines.concat(authLine.dtl_list);
    }

    let cSubAmt10 = 0, cTaxAmt10 = 0;
    let cSubAmtEx10 = 0, cTaxAmtEx10 = 0;
    let cSubAmtEx08 = 0, cTaxAmtEx08 = 0;
    let cSubAmtExExempt = 0, cSubAmtExNonTax = 0;

    allLines.filter(o =>
      o.expense_cl !== CONST_EXPENSE_CL_TAX_10 &&
      o.expense_cl !== CONST_EXPENSE_CL_TAX_08 &&
      o.expense_cl !== CONST_EXPENSE_CL_TAX_EXEMPT &&
      o.expense_cl !== CONST_EXPENSE_CL_TAX_NON_TAX
    ).forEach(line => {
      cSubAmt10 += line.line_amount ? Number(line.line_amount) : 0;
      cTaxAmt10 += line.line_tax_amount ? Number(line.line_tax_amount) : 0;
    });

    allLines.forEach(line => {
      if (line.expense_cl === CONST_EXPENSE_CL_TAX_10) {
        cSubAmtEx10 += line.line_amount_ex ? Number(line.line_amount_ex) : 0;
        cTaxAmtEx10 += line.line_tax_amount ? Number(line.line_tax_amount) : 0;
      }
      if (line.expense_cl === CONST_EXPENSE_CL_TAX_08) {
        cSubAmtEx08 += line.line_amount_ex ? Number(line.line_amount_ex) : 0;
        cTaxAmtEx08 += line.line_tax_amount ? Number(line.line_tax_amount) : 0;
      }
      if (line.expense_cl === CONST_EXPENSE_CL_TAX_EXEMPT) {
        cSubAmtExExempt += line.line_amount_ex ? Number(line.line_amount_ex) : 0;
      }
      if (line.expense_cl === CONST_EXPENSE_CL_TAX_NON_TAX) {
        cSubAmtExNonTax += line.line_amount_ex ? Number(line.line_amount_ex) : 0;
      }
    });

    const cTotalAmtNew = cSubAmt10 + cTaxAmt10 + cSubAmtEx10 + cSubAmtEx08 + cSubAmtExExempt + cSubAmtExNonTax;
    await patchAPI("tr_pay/" + cPayId + "/", {
      sub_amount: cSubAmt10,
      tax_amount: cTaxAmt10,
      sub_w_tax_amount: cSubAmt10 + cTaxAmt10,
      sub_amount_ex: (cSubAmtEx10 - cTaxAmtEx10) + (cSubAmtEx08 - cTaxAmtEx08) + cSubAmtExExempt + cSubAmtExNonTax,
      tax_rate_ex: null,
      tax_amount_ex: cTaxAmtEx10 + cTaxAmtEx08,
      sub_w_tax_amount_ex: cSubAmtEx10 + cSubAmtEx08 + cSubAmtExExempt + cSubAmtExNonTax,
      sub_amount_00: cSubAmtExExempt + cSubAmtExNonTax,
      tax_amount_00: 0,
      sub_amount_08: cSubAmtEx08 - cTaxAmtEx08,
      tax_amount_08: cTaxAmtEx08,
      sub_amount_10: cSubAmtEx10 - cTaxAmtEx10,
      tax_amount_10: cTaxAmtEx10,
      total_amount: cTotalAmtNew,
    });

    setLineList([]);
    setModalLineList([]);
    setModalShow(false);
    setDispCount(dispCount + 1);
  }

  const modalBulkSave = async (cPayId, locLineList) => {

    let updatedLineList = [];
    for (let i = 0; i < locLineList.length; i++) {
      let cLine = locLineList[i];
      if (modalAuthorCd === cLine.author_cd && !cLine.is_line_updated) {
        //更新なし
        updatedLineList.push(locLineList[i])
        continue;
      }

      if (cLine.pay_dtl_id && !cLine.acc_cd) {
        //明細削除
        await deleteAPI("tr_pay_dtl/" + cLine.pay_dtl_id);

      } else if (!cLine.pay_dtl_id) {
        //明細追加
        let obj = {};
        obj.pay_id = cPayId;
        obj.grp_no = 0;
        obj.line_no = i + 1;
        obj.author_cd = toNull(modalAuthorCd);
        obj.expense_cl = toNull(cLine.expense_cl);
        obj.acc_cd = toNull(cLine.acc_cd);
        obj.acc_suffix_cd = toNull(cLine.acc_suffix_cd);
        obj.inv_no = toNull(cLine.inv_no);
        obj.dept_cd = toNull(modalDeptCd);
        obj.remark_cd = toNull(cLine.remark_cd);
        obj.note = toNull(cLine.note);
        obj.price = toNull(cLine.price);
        obj.qty = toNull(cLine.qty);
        obj.page = toNull(cLine.page);
        obj.line_amount = toNull(cLine.line_amount);
        obj.line_amount_ex = toNull(cLine.line_amount_ex);
        obj.line_tax_type_cd = toNull(cLine.line_tax_type_cd);
        obj.line_tax_rate = toNull(cLine.line_tax_rate);
        obj.line_tax_amount = toNull(cLine.line_tax_amount);
        obj.line_total_amount = toNull(cLine.line_total_amount);
        obj.line_withhold_tax_amount = toNull(cLine.line_withhold_tax_amount);
        obj.line_pay_amount = toNull(cLine.line_pay_amount);
        obj.create_pg = "PayDtl"
        obj.update_pg = "PayDtl"
        obj = await postAPI("tr_pay_dtl/", obj);

      } else {
        //更新
        let obj = await getAPI("tr_pay_dtl/" + cLine.pay_dtl_id);
        obj.grp_no = 0;
        obj.line_no = i + 1;
        obj.author_cd = toNull(modalAuthorCd);
        obj.expense_cl = toNull(cLine.expense_cl);
        obj.acc_cd = toNull(cLine.acc_cd);
        obj.acc_suffix_cd = toNull(cLine.acc_suffix_cd);
        obj.inv_no = toNull(cLine.inv_no);
        obj.dept_cd = toNull(modalDeptCd);
        obj.remark_cd = toNull(cLine.remark_cd);
        obj.note = toNull(cLine.note);
        obj.price = toNull(cLine.price);
        obj.qty = toNull(cLine.qty);
        obj.page = toNull(cLine.page);
        obj.line_amount = toNull(cLine.line_amount);
        obj.line_amount_ex = toNull(cLine.line_amount_ex);
        obj.line_tax_type_cd = toNull(cLine.line_tax_type_cd);
        obj.line_tax_rate = toNull(cLine.line_tax_rate);
        obj.line_tax_amount = toNull(cLine.line_tax_amount);
        obj.line_total_amount = toNull(cLine.line_total_amount);
        obj.line_withhold_tax_amount = toNull(cLine.line_withhold_tax_amount);
        obj.line_pay_amount = toNull(cLine.line_pay_amount);
        obj.update_pg = "PayDtl"
        obj = await putAPI("tr_pay_dtl/" + cLine.pay_dtl_id + "/", obj);
      }
      updatedLineList.push(cLine);
    }
    return updatedLineList;
  }

  const handleChangeAuthor = async (value) => {
    if (!value) {
      setModalAuthorSelected(null);
      setModalAuthorCd("");
      return;
    }
    setModalAuthorSelected({
      name: value.name,
      id: value.id,
      option: value.name
    });
    setModalAuthorCd(value.id);
    setModalDispAuthorPennameNm(value.penname_nm);

    let cAuthorCd = value.id;
    let cModalDispAuthorCd = "";
    let cModalDispAuthorTel = "";
    let cModalDispAuthorCellPhoneNo = "";
    let cModalDispAuthorAddr = "";
    let cModalDispAuthorAddrSend = "";
    let cModalDispAuthorTelSend = "";
    let cModalDispEmailAddressAuthor = "";
    let cModalDispBankAccountNm = "";
    let cModalDispBankAccount = "";
    let cModalCommorancyCl = "";
    let cModalConsumptionTax = "";
    let cModalRoundingOffCl = "";
    let cModalWithholdingObjectCl = "";
    let cModalDutyFreeFG = "";
    let cModalDispAuthorTekikakuNo = "";

    // 支払先セット
    let obj = null;
    let searchCondition = {
      customer_cd: value.id
    };
    res = await getAPI("ms_author_search_view", searchCondition);
    if (res.count > 0) {
      obj = res.results[0];
    }
    if (obj) {
      cModalDispAuthorCd = nvl(obj.author_cd);
      cModalDispAuthorTel = nvl(obj.author_tel);
      cModalDispAuthorCellPhoneNo = nvl(obj.author_cell_phone_no);
      cModalDispAuthorAddr = nvl(obj.author_zipcode) + " " + nvl(obj.author_address_1) + nvl(obj.author_address_2) + nvl(obj.author_address_3);
      cModalDispAuthorAddrSend = nvl(obj.zipcode_send1) + " " + nvl(obj.address1_send1) + nvl(obj.address1_send2) + nvl(obj.address1_send3);
      cModalDispAuthorTelSend = nvl(obj.tel_send1);
      cModalDispEmailAddressAuthor = nvl(obj.email_address_author);
      cModalCommorancyCl = nvl(obj.commorancy_cl);
      cModalConsumptionTax = obj.consumption_tax === 0 ? sysConsumptionTaxCl : nvl(obj.consumption_tax);
      cModalRoundingOffCl = obj.rounding_off_cl === 1 ? sysRoundingOffCl : nvl(obj.rounding_off_cl);
      cModalWithholdingObjectCl = nvl(obj.withholding_object_cl);
      cModalDutyFreeFG = nvl(obj.duty_free);
      cModalDispAuthorTekikakuNo = nvl(obj.author_tekikaku_no);

      // 口座情報セット
      cModalDispBankAccountNm = nvl(obj.bank_account_nm);
      searchCondition = {
        bank_cd: obj.bank_cd,
        bank_branch_cd: obj.bank_branch_cd
      }
      let oBank = await getAPI("ms_bank", searchCondition);
      if (oBank.count === 1) {
        let o = oBank.results[0];
        cModalDispBankAccount = "";
        cModalDispBankAccount += nvl(o.bank_nm);
        cModalDispBankAccount += "(" + nvl(o.bank_cd) + ")";
        cModalDispBankAccount += "　";
        cModalDispBankAccount += nvl(o.bank_branch_nm);
        cModalDispBankAccount += "(" + nvl(o.bank_branch_cd) + ")";
        cModalDispBankAccount += "　";
        if (obj.kind_of_account_cl === "0") {
          cModalDispBankAccount += "普通";
        } else if (obj.kind_of_account_cd === "1") {
          cModalDispBankAccount += "当座";
        } else if (obj.kind_of_account_cd === "9") {
          cModalDispBankAccount += "総合";
        }
        cModalDispBankAccount += "　";
        cModalDispBankAccount += nvl(obj.bank_account_no);
      }
    }
    setModalDispAuthorCd(cModalDispAuthorCd);
    setModalDispAuthorTel(cModalDispAuthorTel);
    setModalDispAuthorCellPhoneNo(cModalDispAuthorCellPhoneNo);
    setModalDispAuthorAddr(cModalDispAuthorAddr);
    setModalDispAuthorAddrSend(cModalDispAuthorAddrSend);
    setModalDispAuthorTelSend(cModalDispAuthorTelSend);
    setModalDispEmailAddressAuthor(cModalDispEmailAddressAuthor);
    setModalDispBankAccountNm(cModalDispBankAccountNm);
    setModalDispBankAccount(cModalDispBankAccount);
    setModalCommorancyCl(cModalCommorancyCl);
    setModalConsumptionTax(cModalConsumptionTax);
    setModalRoundingOffCl(cModalRoundingOffCl);
    setModalWithholdingObjectCl(cModalWithholdingObjectCl);
    setModalDutyFreeFG(cModalDutyFreeFG);
    setModalDispAuthorTekikakuNo(cModalDispAuthorTekikakuNo);
    await onKeyDownNext();
  }

  const onSearchAuthor = async (query) => {
    let obj = null;
    let searchCondition = {
      search_word: query,
      pay_grp_type: "原稿料",
    };
    res = await getAPI("ms_author_search_view", searchCondition);
    let options = [{
      option: rpad("ID", 7, ' ') + rpad("名", 20, ' ') + rpad("ペンネーム", 20, ' ') + "住所",
      id: "",
      name: "",
      penname_nm: "",
      isHeader: true
    }];
    res.results.map((obj) => (
      options.push({
        option:
          nvl(obj.author_cd) + " " +
          rpad(nvl(obj.customer_nm), 20, ' ') +
          rpad(nvl(obj.penname_nm), 20, ' ') +
          (nvl(obj.author_address_1) + nvl(obj.author_address_2) + nvl(obj.author_address_3)).trim(),
        id: obj.author_cd,
        name: nvl(obj.author_cd) + " " + nvl(obj.customer_nm),
        penname_nm: nvl(obj.penname_nm)
      })));
    return options;
  }

  const onSearchDept = async (query) => {
    let searchCondition = {
      search_value: query
    }
    const res = await getAPI("ms_dept_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: lpad(nvl(obj.dept_cd), 2, "0") + " " + nvl(obj.dept_nm),
      id: obj.dept_cd
    }));
    return o;
    await onKeyDownNext();
  }

  const handleChangeDept = async (value) => {
    setModalDeptSelected(value);
    setModalDeptCd(value ? value.id : "");
    onKeyDownNext();
  }

  const totaling = (cLineList) => {
    let cSumQty = 0;
    let cSumPage = 0;
    let cSumAmount = 0;
    let cSumAmountEx = 0;

    for (let cLine of cLineList) {
      cSumQty += cLine.qty ? cLine.qty : 0;
      cSumPage += cLine.page ? cLine.page : 0;
      cSumAmount += cLine.line_amount && !isExpense(cLine.expense_cl) ? cLine.line_amount : 0;
      cSumAmountEx += cLine.line_amount_ex && isExpense(cLine.expense_cl) ? cLine.line_amount_ex : 0;
    }
    setModalSumQty(cSumQty);
    setModalSumPage(cSumPage);
    setModalSumAmount(cSumAmount);
    setModalSumAmountEx(cSumAmountEx);

    for (let i = 0; i < cLineList.length; i++) {

      if (!cLineList[i].line_amount && !cLineList[i].line_amount_ex) {
        continue;
      }

      // let cTaxType = CONST_EXPENSE_CL_TAX_10; // 外税(デフォルト)
      let taxRate = 0.1;
      if (cLineList[i].expense_cl === CONST_EXPENSE_CL_TAX_08) {
        taxRate = 0.08;
      } else if (cLineList[i].expense_cl === CONST_EXPENSE_CL_TAX_EXEMPT || cLineList[i].expense_cl === CONST_EXPENSE_CL_TAX_NON_TAX) {
        taxRate = 0;
      }

      // 金額、消費税、税込合計
      if (cLineList[i].expense_cl !== CONST_EXPENSE_CL_TAX_10 && cLineList[i].expense_cl !== CONST_EXPENSE_CL_TAX_08 && cLineList[i].expense_cl !== CONST_EXPENSE_CL_TAX_EXEMPT && cLineList[i].expense_cl !== CONST_EXPENSE_CL_TAX_NON_TAX) {
        // 外税
        cLineList[i].line_tax_amount = r(cLineList[i].line_amount * taxRate, R_ROUND, 0);
        cLineList[i].line_total_amount = cLineList[i].line_amount + cLineList[i].line_tax_amount;
      } else if (cLineList[i].expense_cl === CONST_EXPENSE_CL_TAX_10 || cLineList[i].expense_cl === CONST_EXPENSE_CL_TAX_08) {
        // 内税
        cLineList[i].line_total_amount = cLineList[i].line_amount_ex;
        cLineList[i].line_tax_amount = r(cLineList[i].line_total_amount / (1 + taxRate) * taxRate, R_ROUND, 0);
        cLineList[i].line_amount = cLineList[i].line_total_amount - cLineList[i].line_tax_amount;
      } else {
        // 非課税・不課税
        cLineList[i].line_tax_amount = 0;
        cLineList[i].line_total_amount = cLineList[i].line_amount;
      }
    }

    // 集計 //////////////////////////////////////////////////////////////////////////////
    let list = [];
    // 原稿料
    let cSubAmt10 = 0;
    let cTaxAmt10 = 0;
    let cWithholdTaxAmt = 0;
    list = cLineList.filter(o =>
      o.expense_cl !== CONST_EXPENSE_CL_TAX_10 &&
      o.expense_cl !== CONST_EXPENSE_CL_TAX_08 &&
      o.expense_cl !== CONST_EXPENSE_CL_TAX_EXEMPT &&
      o.expense_cl !== CONST_EXPENSE_CL_TAX_NON_TAX);
    list.forEach((line, index) => {
      cSubAmt10 += line.line_amount ? line.line_amount : 0;
      cTaxAmt10 += line.line_tax_amount ? line.line_tax_amount : 0;
      cWithholdTaxAmt += line.line_withhold_tax_amount ? line.line_withhold_tax_amount : 0;
    });

    //　経費
    let cSubAmtEx10 = 0;
    let cTaxAmtEx10 = 0;
    let cSubAmtEx08 = 0;
    let cTaxAmtEx08 = 0;
    let cSubAmtExExempt = 0;
    let cTaxAmtExExempt = 0;
    let cSubAmtExNonTax = 0;
    let cTaxAmtExNonTax = 0;
    cLineList.forEach((line, index) => {
      if (line.expense_cl === CONST_EXPENSE_CL_TAX_10) {
        cSubAmtEx10 += line.line_amount_ex ? line.line_amount_ex : 0;
        cTaxAmtEx10 += line.line_tax_amount ? line.line_tax_amount : 0;
      }
      if (line.expense_cl === CONST_EXPENSE_CL_TAX_08) {
        cSubAmtEx08 += line.line_amount_ex ? line.line_amount_ex : 0;
        cTaxAmtEx08 += line.line_tax_amount ? line.line_tax_amount : 0;
      }
      if (line.expense_cl === CONST_EXPENSE_CL_TAX_EXEMPT) {
        cSubAmtExExempt += line.line_amount_ex ? line.line_amount_ex : 0;
        cTaxAmtExExempt += line.line_tax_amount ? line.line_tax_amount : 0;
      }
      if (line.expense_cl === CONST_EXPENSE_CL_TAX_NON_TAX) {
        cSubAmtExNonTax += line.line_amount_ex ? line.line_amount_ex : 0;
        cTaxAmtExNonTax += line.line_tax_amount ? line.line_tax_amount : 0;
      }
    });

    // 合計等
    let cTotalAmt = cSubAmt10 + cTaxAmt10 + cSubAmtEx10 + cSubAmtEx08 + cSubAmtExExempt + cSubAmtExNonTax;
    let cHandingCharge = 0 //手数料なし（固定）
    let cPayAmt = cTotalAmt - cWithholdTaxAmt - cHandingCharge;

    for (let i = 0; i < cLineList.length; i++) {
      if (!cLineList[i].expense_cl) {
        continue;
      }
      modalLineListRef.current[i].current.setLineTaxAmount(cLineList[i].line_tax_amount);
      modalLineListRef.current[i].current.setLineTotalAmount(cLineList[i].line_total_amount);
      modalLineListRef.current[i].current.setLineWithholdTaxAmount(cLineList[i].line_withhold_tax_amount);
      modalLineListRef.current[i].current.setLinePayAmount(cLineList[i].line_pay_amount);
    }

    setModalSubAmt10(cSubAmt10);
    setModalTaxAmt10(cTaxAmt10);
    setModalSubAmtEx10(cSubAmtEx10);
    setModalTaxAmtEx10(cTaxAmtEx10);
    setModalSubAmtEx08(cSubAmtEx08);
    setModalTaxAmtEx08(cTaxAmtEx08);
    setModalSubAmtExExempt(cSubAmtExExempt);
    setModalTaxAmtExExempt(cTaxAmtExExempt);
    setModalSubAmtExNonTax(cSubAmtExNonTax);
    setModalTaxAmtExNonTax(cTaxAmtExNonTax);
    setModalWithholdTaxAmt(cWithholdTaxAmt);
    setModalTotalAmt(cTotalAmt);
    setModalHandlingCharge(0);
    setModalPayAmt(cPayAmt);
  }

  const calcTotal = async () => {

    let cLineList = [];
    modalLineListRef.current.map(lineList => {
      if (lineList.current.getStates().index == null) {
        return undefined;
      }
      cLineList.push(lineList.current.getStates());
    });

    totaling(cLineList);
  }

  const onClickDeleteModal = async () => {
    const res = await getAPI("tr_pay_dtl_list_search_view", { pay_id: payId, author_cd: modalAuthorCd });
    for (const authLine of res.results) {
      for (const line of authLine.dtl_list) {
        await deleteAPI("tr_pay_dtl/" + line.pay_dtl_id);
      }
    }
    setConfirmModalShow(false);

    setLineList([]);
    setModalLineList([]);
    setModalShow(false);
    setDispCount(dispCount + 1);
    success("取消が完了しました");
  }

  // ショートカットキー：Ctl＋Enter
  const onKeyDownCtlEnterModal = async () => {
    await onClickSavePayDtlModal();
  }

  // ショートカットキー：Escape
  const onKeyDownEscModal = async () => {
    const e = document.activeElement;
    if (e && e.tabIndex === 1010) {
      await onClickCloseModal();
    } else {
      await sleepByPromise(0.02);
      moveFocusByTabIndex(1010); //支払先をフォーカス
    }
  }

  // 確認ダイアログ ////////////////////////////////////////////////////////////////////////
  const onClickShowConfirmModal = async (pConfirmModalType) => {
    setConfirmModalType(pConfirmModalType);
    setConfirmModalShow(true);
  }

  const onClickCloseConfirmModal = async () => {
    setConfirmModalShow(false);
  }

  const onClickDelete = async () => {
    // ヘッダのみ論理削除（明細は物理削除しない。BAPAYDTの削除フラグはサーバ側で処理）
    await deleteAPI("tr_pay/" + payId + "/", { delete_pg: "PayDtl" });
    setConfirmModalShow(false);
    success("取消が完了しました");
    history.push(RoutePaths.root.pay_list);
  }

  // 基準日ダイアログ ///////////////////////////////////////////////////////////////////////////
  const onClickShowPayDateModal = async () => {
    setModalPayDateShow(true);
  }

  const onClickCloseModalPayDate = async () => {
    setModalPayDateShow(false);
  }

  const onClickSelectPayDate = async (pPayDate) => {
    setPayDate(pPayDate);
    setModalPayDateShow(false);
  }

  // グループダイアログ //////////////////////////////////////////////////////////////////////////
  const onClickShowPayGrpModal = async () => {
    setPayGrpModalShow(true);
  }

  const onClickClosePayGrpModal = async () => {
    setPayGrpModalShow(false);
  }

  // ショートカットキー：Ctl＋Enter
  const onKeyDownCtlEnter = async (e) => {
    if (!disabledBtnPaySave) {
      e.preventDefault();
      await onClickPaySave();
    }
  }

  // ショートカットキー：Escape
  const onKeyDownEsc = async (e) => {
    if (e.target && e.target.id === "expDate") {
      e.preventDefault();
      history.push(RoutePaths.root.pay_list);　//前画面に戻る
    } else {
      e.preventDefault();
      await focusById("expDate");
    }
  }

  // ショートカットキー：Space
  const onKeyDownSpace = async (e) => {
    if (e && e.target && e.target.getAttribute("author_cd")) {
      //編集ダイアログ
      e.preventDefault();
      await onClickShowModal(e.target.getAttribute("author_cd"));
    }
    if (e && e.target && e.target.id === "btn-pay-add") {
      //新規ダイアログ
      e.preventDefault();
      await onClickShowModal();
    }
  }

  // ショートカットキー：Enter
  const onKeyDownEnter = async (e) => {
    await onKeyDownNext(e);
  }

  // カレンダー用 ////////////////////////////////////////////////////////////////////////////////////////
  const [openCalExpDate, setOpenCalExpDate] = useState(false);
  const handleChangeCalExpDate = async (dateObj) => {
    setExpDate(dateformatYYYY_MM_DD(dateObj))
    setOpenCalExpDate(false);
    await focusById("expDate");
  };

  const [openCalPayDate, setOpenCalPayDate] = useState(false);
  const handleChangeCalPayDate = async (dateObj) => {
    setPayDate(dateformatYYYY_MM_DD(dateObj))
    setOpenCalPayDate(false);
    await focusById("payDate");
  };

  return (
    <div>
      {/*内訳一覧*/}
      <div className="body-dtl body-dtl-const">
        <AppNav />
        <div
          style={{ maxWidth: "1400px", margin: "0 auto" }}
          onKeyDown={(e) => onKeyDownShortCut(e, null, () => onKeyDownCtlEnter(e), () => onKeyDownEsc(e), () => onKeyDownSpace(e), () => onKeyDownEnter(e))}
        >
          <Row className="h1">
            <Col sm="3">
              <h1>
                支払内訳
              </h1>
            </Col>
            <Col sm="9" className="text-right">
              <Button as={Link} to={RoutePaths.root.pay_list} variant="quaternary" className="mr-4">
                戻る
              </Button>
              {payId &&
                <Button variant="quaternary" className="mr-4" onClick={e => onClickNewPayDtl()}>
                  追加支払
                </Button>
              }
              <Button variant="tertiary" className="mr-4" onClick={e => onClickShowConfirmModal("ヘッダ")}
                disabled={!status || status === "支払済"}>
                取消
              </Button>
            </Col>
          </Row>
          <Container className="container-main-detail-header">
            <Form.Group as={Row} style={{ marginRight: "-15px", marginLeft: "-15px" }}>
              <Form.Label column sm="1" style={{ borderTop: "solid 1px #e3e5e9" }}>
                処理日
              </Form.Label>
              <Col sm="2" className="input-group p-0 input-col" style={{ borderTop: "solid 1px #e3e5e9" }}>
                <div className="input-group">
                  <Form.Control
                    id="expDate"
                    type="text"
                    className="text-center"
                    tabIndex={10}
                    value={expDate}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setExpDate(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setExpDate(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                    autoFocus={true}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalExpDate(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar} />
                  </button>
                </div>
                <DatePicker
                  wrapperClassName="display-none-date-wrapper"
                  selected={dateformatDatePicker(toSingleByteNumberOnly(expDate))}
                  onChange={handleChangeCalExpDate}
                  open={openCalExpDate}
                  onClickOutside={e => setOpenCalExpDate(false)}
                  customInput={<div style={{ display: "none" }} />}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
              </Col>
              <Form.Label column sm="1" style={{ borderTop: "solid 1px #e3e5e9" }}>
                支払日
              </Form.Label>
              <Col sm="2" className="input-group p-0 input-col" style={{ borderTop: "solid 1px #e3e5e9" }}>
                <div className="input-group">
                  <Form.Control
                    id="payDate"
                    type="text"
                    className="text-center"
                    tabIndex={11}
                    value={payDate}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setPayDate(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setPayDate(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalPayDate(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar} />
                  </button>
                </div>
                <DatePicker
                  wrapperClassName="display-none-date-wrapper"
                  selected={dateformatDatePicker(toSingleByteNumberOnly(payDate))}
                  onChange={handleChangeCalPayDate}
                  open={openCalPayDate}
                  onClickOutside={e => setOpenCalPayDate(false)}
                  customInput={<div style={{ display: "none" }} />}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />

              </Col>
              <Form.Label column sm="1" style={{ borderTop: "solid 1px #e3e5e9" }}>
                Gno
              </Form.Label>
              <Col sm="1" className="input-group p-0 input-col" style={{ borderTop: "solid 1px #e3e5e9", display: "flex" }}>
                <Form.Control
                  type="text"
                  tabIndex={12}
                  inputMode="numeric"
                  style={{ borderRadius: "0", textAlign: "center", flex: "1 1 auto", minWidth: "0" }}
                  value={payGrpNum}
                  onKeyPress={e => {
                    checkKey(e, /[0-9\-]/);
                    if (isEnterKey(e)) {
                      onKeyDownNext(e);
                    }
                  }}
                  onFocus={e => onFocusText(e)}
                  onChange={e => setPayGrpNum(e.target.value)} />
              </Col>
              <Form.Label column sm="1" style={{ borderTop: "solid 1px #e3e5e9" }}>
                ステータス
              </Form.Label>
              <Col sm="3" style={{ borderTop: "solid 1px #e3e5e9", paddingTop: "4px" }}>
                <div className={
                  !status ? 'tag-status status-0 text-center' :
                    status === '新規' ? 'tag-status status-00 text-center' :
                      status === '支払前' ? 'tag-status status-01 text-center' :
                        status === '副社長承認中' ? 'tag-status status-10 text-center' :
                          status === '社長承認中' ? 'tag-status status-20 text-center' :
                            status === '処理中' ? 'tag-status status-30 text-center' :
                              status === '支払済' ? 'tag-status status-90 text-center' :
                                'd-inline-block'
                }
                  style={{ width: "130px" }}
                >
                  {status ? status : "未作成"}
                </div>
              </Col>

            </Form.Group>
            <Form.Group as={Row} style={{ marginRight: "-15px", marginLeft: "-15px" }}>
              <Form.Label column sm="1">
                商品番号
              </Form.Label>
              <Col sm="1">
                <Form.Control plaintext readOnly tabIndex={-1} defaultValue={itemCd} />
              </Col>
              <Form.Label column sm="1">
                支払予定
              </Form.Label>
              <Col sm="1">
                <Form.Control className="text-center" plaintext readOnly tabIndex={-1} defaultValue={schedulePayMonth} />
              </Col>
              <Form.Label column sm="1">
                配本日
              </Form.Label>
              <Col sm="1">
                <Form.Control className="text-center" plaintext readOnly tabIndex={-1} defaultValue={distributionDate} />
              </Col>
              <Form.Label column sm="1">
                企画コード
              </Form.Label>
              <Col sm="1">
                <Form.Control plaintext readOnly tabIndex={-1} defaultValue={costCd} />
              </Col>
              <Form.Label column sm="1">
                担当者
              </Form.Label>
              <Col sm="2">
                <Form.Control plaintext readOnly tabIndex={-1} defaultValue={picName} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} style={{ marginRight: "-15px", marginLeft: "-15px" }}>
              <Form.Label column sm="1">
                分類
              </Form.Label>
              <Col sm="3">
                <Form.Control plaintext readOnly tabIndex={-1} defaultValue={grpNameS} />
              </Col>
              <Form.Label column sm="1">
                商品名
              </Form.Label>
              <Col sm="7">
                <Form.Control plaintext readOnly tabIndex={-1} defaultValue={itemName} />
              </Col>
            </Form.Group>
          </Container>
          <Container className="container-main-detail-list pb-2">
            {lineList.length > 0 &&
              <div className="pb-2">
                <Row style={{ width: "14%", marginLeft: "auto" }}>
                  {/*<Col className="tbl-h-00-h-col tbl-h-00-start tbl-h-00-top">小計</Col>*/}
                  {/*<Col className="tbl-h-00-h-col tbl-h-00-top">税</Col>*/}
                  <Col lg="12" className="tbl-h-00-h-col tbl-h-00-start tbl-h-00-top">支払金額</Col>
                </Row>
                <Row className="tbl-b-00" style={{ width: "14%", marginLeft: "auto" }}>
                  {/*<Col lg="4" className="col-num tbl-b-00-start" style={{padding: ".375rem"}}>{formatNumber(subAmount)}</Col>*/}
                  {/*<Col lg="4" className="col-num" style={{padding: ".375rem"}}>{formatNumber(taxAmount)}</Col>*/}
                  <Col lg="12" className="col-num tbl-b-00-start" style={{ padding: ".375rem" }}>{formatNumber(totalAmount)}</Col>
                </Row>
              </div>
            }
            {lineList.length > 0 &&
              <Row className="tbl-h-00">
                <Col lg="2" className="tbl-h-00-start" style={{ borderTop: "1px solid rgb(227, 229, 233)" }}>支払先</Col>
                <Col lg="10" style={{ border: "solid 0px" }}>
                  <Row className="tbl-h-00" style={{ border: "0px" }}>
                    <Col lg="2" className="tbl-h-00-top">種目</Col>
                    <Col lg="2" className="tbl-h-00-top">請求書No.</Col>
                    <Col lg="3" className="tbl-h-00-top">摘要</Col>
                    <Col lg="1" className="tbl-h-00-top">単価</Col>
                    <Col lg="1" className="tbl-h-00-top">合計点数</Col>
                    <Col lg="1" className="tbl-h-00-top">合計頁</Col>
                    <Col lg="1" className="tbl-h-00-top">合計金額</Col>
                    <Col lg="1" className="tbl-h-00-top">経費</Col>
                  </Row>
                </Col>
              </Row>
            }
            {lineList.map((line, index) => (
              <Row
                key={index}
                tabIndex={100 + index}
                author_cd={line.author_cd}
                className="tbl-b-00 selectable-row"
                onClick={e => onClickShowModal(line.author_cd)}
                style={{ borderTop: "1px solid #FFFFFF", borderRight: "1px solid #FFFFFF", borderBottom: "1px solid #ced4da", borderLeft: "1px solid #FFFFFF", }}
              >
                <Col lg="2" className="tbl-b-00-start" style={{ padding: ".375rem", borderBottom: "0px" }}>
                  {line.customer_nm}
                </Col>
                <Col lg="10" style={{ border: "none" }}>
                  {line.dtl_list.map((line2, index2) => (
                    <Row key={index2} className={line.dtl_list.length === index2 + 1 ? "last-row" : ""}>
                      <Col lg="2" style={{ padding: ".375rem" }}>{lpad(nvl(line2.expense_cl), 2, "0") + " " + nvl(line2.expense_cl_nm)}</Col>
                      <Col lg="2" style={{ padding: ".375rem" }}>{line2.inv_no}</Col>
                      <Col lg="3" style={{ whiteSpace: "pre-wrap", padding: ".375rem" }}>{line2.note}</Col>
                      <Col lg="1" className="col-num" style={{ padding: ".375rem" }}>{formatNumber(line2.price)}</Col>
                      <Col lg="1" className="col-num" style={{ padding: ".375rem" }}>{formatNumber(line2.qty)}</Col>
                      <Col lg="1" className="col-num" style={{ padding: ".375rem" }}>{formatNumber(line2.page)}</Col>
                      <Col lg="1" className="col-num" style={{ padding: ".375rem" }}>{formatNumber(line2.line_amount)}</Col>
                      <Col lg="1" className="col-num" style={{ padding: ".375rem" }}>{formatNumber(line2.line_amount_ex)}</Col>
                    </Row>
                  ))}
                </Col>
              </Row>
            ))}
            {
              expDate && payDate && payGrpNum &&
              <div
                className="btn-pay-add"
                id="btn-pay-add"
                tabIndex="801"
                next-tabindex={lineList.length ? "100" : "10"}
                onClick={e => onClickShowModal()}>
                <FontAwesomeIcon icon={faPlusCircle} size="lg" style={{ marginRight: "0.5rem" }} />
                支払先の追加
              </div>
            }
            <div className="text-right" style={{ marginLeft: "-15pmb", marginRight: "-15px" }}>
              <Button variant="primary" id="btn-pay-save" onClick={e => onClickPaySave()} disabled={disabledBtnPaySave}>
                保存
              </Button>
            </div>
          </Container>
        </div>
      </div>

      {/*内訳ダイアログ*/}
      <Modal
        id="pay-dtl-dialog"
        show={modalShow}
        onHide={onClickCloseModal}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>原稿料内訳</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-1">
          <Card className="card-search">
            <Container className="container-pay-dtl-dialog pl-0 pr-0"
              onKeyDown={(e) => onKeyDownShortCut(e, null, onClickSavePayDtlModal, onKeyDownEscModal)}>
              <div className="text-right pb-1">
                <Button variant="tertiary" className="mr-4" onClick={e => onClickShowConfirmModal("明細")}
                  disabled={!status || status === "支払済"}>
                  取消
                </Button>
              </div>
              <Form.Group as={Row} style={{ borderLeft: "solid 1px #e3e5e9", borderTop: "solid 1px #e3e5e9" }}>
                <Form.Label column sm="1">
                  商品
                </Form.Label>
                <Col sm="11">
                  <Form.Control plaintext readOnly tabIndex={-1} value={itemCd + " " + grpNameS + " " + itemName} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} style={{ borderLeft: "solid 1px #e3e5e9" }}>
                <Form.Label column sm="1">
                  支払先
                </Form.Label>
                <Col sm="4" className="p-0">
                  <AsyncSelect
                    tabIndex={1000 + 10}
                    id="modalAuthor"
                    className="async-select async-select-author"
                    classNamePrefix="async-select"
                    styles={asyncSelectStyles}
                    components={{ DropdownIndicator: null }}
                    cacheOptions
                    isOptionDisabled={(option) => option.isHeader === true}
                    value={modalAuthorSelected}
                    onMenuOpen={e => setSelectMenuOpen(true)}
                    onMenuClose={e => setSelectMenuOpen(false)}
                    onKeyDown={e => {
                      if (!selectMenuOpen) {
                        setTimeout(() => {
                          onKeyDownNext(e);
                        }, 100); // バグ対応：遅延させることでカーソル表示
                      }
                    }}
                    getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.option}`}
                    getOptionValue={e => e.id}
                    loadOptions={onSearchAuthor}
                    onChange={handleChangeAuthor}
                    placeholder="支払先を検索する。　例：会社名、氏名、ペンネームなど"
                  />
                </Col>
                <Form.Label column sm="1">
                  ペンネーム
                </Form.Label>
                <Col sm="3">
                  <Form.Control plaintext readOnly tabIndex={-1} value={modalDispAuthorPennameNm} />
                </Col>
                <Form.Label column sm="1">
                  携帯
                </Form.Label>
                <Col sm="2" className="input-group">
                  <Form.Control plaintext readOnly tabIndex={-1} value={modalDispAuthorCellPhoneNo} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} style={{ borderLeft: "solid 1px #e3e5e9" }}>
                <Form.Label column sm="1">
                  住所
                </Form.Label>
                <Col sm="8" className="input-group">
                  <Form.Control plaintext readOnly tabIndex={-1} value={modalDispAuthorAddr} />
                </Col>
                <Form.Label column sm="1">
                  電話 自宅
                </Form.Label>
                <Col sm="2" className="input-group">
                  <Form.Control plaintext readOnly tabIndex={-1} value={modalDispAuthorTel} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} style={{ borderLeft: "solid 1px #e3e5e9" }}>
                <Form.Label column sm="1">
                  勤務先
                </Form.Label>
                <Col sm="8" className="input-group">
                  <Form.Control plaintext readOnly tabIndex={-1} value={modalDispAuthorAddrSend} />
                </Col>
                <Form.Label column sm="1">
                  電話 勤務先
                </Form.Label>
                <Col sm="2" className="input-group">
                  <Form.Control plaintext readOnly tabIndex={-1} value={modalDispAuthorTelSend} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} style={{ borderLeft: "solid 1px #e3e5e9" }}>
                <Form.Label column sm="1">
                  口座名義
                </Form.Label>
                <Col sm="2" className="input-group">
                  <Form.Control plaintext readOnly tabIndex={-1} value={modalDispBankAccountNm} />
                </Col>
                <Form.Label column sm="1">
                  口座
                </Form.Label>
                <Col sm="5" className="input-group">
                  <Form.Control plaintext readOnly tabIndex={-1} value={modalDispBankAccount} />
                </Col>
                <Form.Label column sm="1">
                  メール
                </Form.Label>
                <Col sm="2" className="input-group">
                  <Form.Control plaintext readOnly tabIndex={-1} value={modalDispEmailAddressAuthor} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1" style={{ borderRight: "solid 0px #e3e5e9", borderBottom: "solid 0px #e3e5e9" }}>
                <Form.Label column sm="1" style={{ borderLeft: "solid 1px #e3e5e9", borderBottom: "solid 1px #e3e5e9" }}>
                  部門
                </Form.Label>
                <Col sm="2" className="p-0" style={{ borderRight: "solid 1px #e3e5e9", borderBottom: "solid 1px #e3e5e9" }}>
                  <AsyncSelect
                    tabIndex={1000 + 11}
                    className="async-select"
                    // className="async-select modal-form-field col-async-select"
                    classNamePrefix="async-select"
                    components={{ DropdownIndicator: null, ClearIndicator: null }}
                    cacheOptions
                    defaultOptions
                    value={modalDeptSelected}
                    onMenuOpen={e => setSelectMenuOpen(true)}
                    onMenuClose={e => setSelectMenuOpen(false)}
                    onKeyDown={e => {
                      if (!selectMenuOpen) {
                        if (e.key === "ArrowDown") {
                          setSelectMenuOpen(true);
                          return;
                        }
                        setTimeout(() => {
                          onKeyDownNext(e);
                        }, 100); // バグ対応：遅延させることでカーソル表示
                      }
                    }}
                    getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                    getOptionValue={e => e.id}
                    loadOptions={e => onSearchDept(e)}
                    onChange={handleChangeDept}
                    placeholder=""
                    isClearable
                  />
                </Col>
                <Form.Label column sm="1">
                  インボイス№
                </Form.Label>
                <Col sm="8" className="input-group" style={{ borderRight: "solid 1px #e3e5e9", borderBottom: "solid 1px #e3e5e9" }}>
                  {modalDutyFreeFG === 1 &&
                    <Form.Control plaintext readOnly tabIndex={-1} value={"免税事業者"} />
                  }
                  {modalDutyFreeFG === 0 &&
                    <Form.Control plaintext readOnly tabIndex={-1} value={modalDispAuthorTekikakuNo} />
                  }
                </Col>
              </Form.Group>
            </Container>
            <div className="container-main-detail-list container d-flex flex-row pl-0">
              <div style={{ flex: "88 1 0%" }}>
                <div className="tbl-h-00 d-flex flex-row">
                  <div className="container" style={{ flex: "70 1 0%", padding: "0" }}>
                    <Row className="tbl-h-00" style={{ marginLeft: "0", marginRight: "0" }}>
                      <Col lg="2" className="tbl-h-00-top tbl-h-00-start col-lg">科目</Col>
                      <Col lg="2" className="tbl-h-00-top col-lg">補助科目</Col>
                      <Col lg="2" className="tbl-h-00-top">カテゴリ</Col>
                      <Col lg="2" className="tbl-h-00-top tbl-h-00-start">請求書No.</Col>
                      <Col lg="4" className="tbl-h-00-top col-lg">摘要</Col>
                    </Row>
                  </div>
                  <div className="container" style={{ flex: "30 1 0%", padding: "0" }}>
                    <Row className="tbl-h-00" style={{ marginLeft: "0", marginRight: "0" }}>
                      <Col className="tbl-h-00-top col-lg tbl-h-00-start">単価</Col>
                      <Col className="tbl-h-00-top col-lg">点数</Col>
                      <Col className="tbl-h-00-top col-lg">頁</Col>
                      <Col className="tbl-h-00-top col-lg">金額</Col>
                      <Col className="tbl-h-00-top col-lg">経費</Col>
                    </Row>
                  </div>
                </div>
                {modalLineList.filter((line) => 1 === 1).map((obj, index) => (
                  <PayDtlLine key={index}
                    ref={modalLineListRef.current[index]}
                    index={index}
                    dutyFreeFG={modalDutyFreeFG}
                    withholdingObjectCl={modalWithholdingObjectCl}
                    consumptionTax={modalConsumptionTax}
                    line={obj}
                    expenseList={modalExpenseList}
                    remarkList={modalRemarkList}
                    accList={modalAccList}
                    accSuffixList={modalAccSuffixList}
                    appendLine={appendLine}
                    calcTotal={calcTotal}
                    onClickSavePayDtlModal={onClickSavePayDtlModal}
                    onKeyDownEscModal={onKeyDownEscModal}
                  />
                ))}
                <div className="d-flex flex-row mt-1">
                  <div className="container" style={{ flex: "70 1 0%", padding: "0" }}></div>
                  <div className="container" style={{ flex: "30 1 0%", padding: "0" }}>
                    <Row className="tbl-b-00 mt-1 ml-0 mr-0">
                      <Col className="ccol-num tbl-h-00-top col-lg"
                        style={{
                          padding: ".375rem",
                          // top: "0",
                          // left: "0",
                          // fontSize: "0.9rem",
                          fontWeight: "bold",
                          textAlign: "center",
                          backgroundColor: "#f1f2f4",
                          // borderTop: "solid 0px #ced4da",
                          borderRight: "solid 1px #ced4da",
                          // borderBottom: "solid 1px #ced4da",
                          borderLeft: "solid 1px #ced4da",
                          // lineHeight: "2.4rem"
                        }}>合計</Col>
                      <Col className="col-num tbl-h-00-top col-lg" style={{ padding: ".375rem" }}>{amountFormatter(modalSumQty)}</Col>
                      <Col className="col-num tbl-h-00-top col-lg" style={{ padding: ".375rem" }}>{amountFormatter(modalSumPage)}</Col>
                      <Col className="col-num tbl-h-00-top col-lg" style={{ padding: ".375rem" }}>{amountFormatter(modalSumAmount)}</Col>
                      <Col className="col-num tbl-h-00-top col-lg" style={{ padding: ".375rem" }}>{amountFormatter(modalSumAmountEx)}</Col>
                    </Row>
                  </div>
                </div>
              </div>
              <div style={{ flex: "12 1 0%" }}>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-top tbl-h-00-start">原稿料</Col>
                  <Col lg="6" className="col-num tbl-h-00-top" style={{ padding: ".375rem" }}>{amountFormatter(modalSubAmt10)}</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">消費税</Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(modalTaxAmt10)}</Col>
                </Row>
                {/*<Row className="ml-1 tbl-b-00">*/}
                {/*  <Col lg="6" className="tbl-h-00 tbl-h-00-start">合計</Col>*/}
                {/*  <Col lg="6" className="col-num" style={{padding: ".375rem"}}>{amountFormatter(modalSubAmt10 + modalTaxAmt10)}</Col>*/}
                {/*</Row>*/}
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">源泉所得</Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(modalWithholdTaxAmt)}</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">金額</Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(modalSubAmt10 + modalTaxAmt10 - modalWithholdTaxAmt)}</Col>
                </Row>

                {modalSubAmtEx10 !== 0 &&
                  <Row className="ml-1 tbl-b-00 mt-1">
                    <Col lg="6" className="tbl-h-00 tbl-h-00-top tbl-h-00-start">経費10%</Col>
                    <Col lg="6" className="col-num tbl-h-00-top" style={{ padding: ".375rem" }}>{amountFormatter(modalSubAmtEx10)}</Col>
                  </Row>
                }
                {modalSubAmtEx08 !== 0 &&
                  <Row className="ml-1 tbl-b-00">
                    <Col lg="6" className="tbl-h-00 tbl-h-00-start">経費 8%</Col>
                    <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(modalSubAmtEx08)}</Col>
                  </Row>
                }
                {modalSubAmtExExempt !== 0 &&
                  <Row className="ml-1 tbl-b-00">
                    <Col lg="6" className="tbl-h-00 tbl-h-00-start">非課税</Col>
                    <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(modalSubAmtExExempt)}</Col>
                  </Row>
                }
                {modalSubAmtExNonTax !== 0 &&
                  <Row className="ml-1 tbl-b-00">
                    <Col lg="6" className="tbl-h-00 tbl-h-00-start">不課税</Col>
                    <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(modalSubAmtExNonTax)}</Col>
                  </Row>
                }
                {(modalSubAmtEx10 + modalSubAmtEx08 !== 0) &&
                  <Row className="ml-1 tbl-b-00">
                    <Col lg="6" className="tbl-h-00 tbl-h-00-start">消費税</Col>
                    <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>({amountFormatter(modalTaxAmtEx10 + modalTaxAmtEx08)})</Col>
                  </Row>
                }
                <Row className="ml-1 tbl-b-00 mt-1">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-top tbl-h-00-start">支払金額</Col>
                  <Col lg="6" className="col-num tbl-h-00-top" style={{ padding: ".375rem" }}>{amountFormatter(modalPayAmt)}</Col>
                </Row>
              </div>
            </div>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={e => onClickSavePayDtlModal()} disabled={disabledBtnPaySave}>
            保存
          </Button>
        </Modal.Footer>
      </Modal>

      {/*確認ダイアログ*/}
      <Modal id="confirm-modal" show={confirmModalShow} onHide={onClickCloseConfirmModal} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>取消確認</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-5 pb-5">
          この支払いを取消してよいですか
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button variant="secondary" onClick={onClickCloseConfirmModal}>
            戻る
          </Button>
          {confirmModalType === "ヘッダ" &&
            <Button variant="danger" onClick={onClickDelete}>
              取消
            </Button>
          }
          {confirmModalType === "明細" &&
            <Button variant="danger" onClick={onClickDeleteModal}>
              取消
            </Button>
          }
        </Modal.Footer>
      </Modal>
      <Toast />
    </div>
  )
    ;
}

export default withRouter(PayDtl);